import {DateTime} from "luxon";

export const getStringHour = (time: number) => {
  let minutes = 0;
  let hours: number;
  const stringTime = time.toString();
  const dotIndex = stringTime.indexOf('.');
  if (dotIndex > 0) {
    hours = +stringTime.substring(0, dotIndex);
    minutes = +stringTime.substring(dotIndex) * 60;
  } else {
    hours = time;
  }

  return `${hours > 9 ? hours : `0${hours}`}:${
    minutes > 9 ? minutes.toFixed(0).substring(0, 2) : `0${minutes.toFixed(0)}`.substring(0, 2)
  }`;
};

export const getNumericHour = (time: string) => {
  const [timeHour, timeMinute] = time.split(':');
  return parseInt(timeHour) + (parseInt(timeMinute) / 60);
}

export const getNumericHourParts = (time: string) => {
  const [timeHour, timeMinute] = time.split(':');
  return {
    hour: parseInt(timeHour),
    minutes: (parseInt(timeMinute) / 60)
  }
}

export const padNumber = (num: string | number): string => {
  return +num > 9 ? `${num}` : `0${num}`;
}

export const getNumberHourFromDate = (date: DateTime): number => {
  return date.hour + (date.minute / 60)
}

export const delay = (time: number) => {
  return new Promise(resolve => setTimeout(resolve, time));
}

export const getFullDate = (date: DateTime): string => {
  return `${date.year}-${padNumber(date.month)}-${padNumber(date.day)} ${padNumber(date.hour)}:${padNumber(date.minute)}`
}
